<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-personnel page-operative-data-analysis-personnel-edit">
    <div class="container">
      <PageTitle>Modifica costo del personale</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Ricavo da modificare non trovato</div>
      <FormCostoPersonale v-else-if="company && userCanEdit" :costo.sync="cost" edit @saved="saveCost" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-personnel-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCostoPersonale: () => import('../../../../components/Operative/Form/FormPersonale'),
  },
  data () {
    return {
      cost: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveCost (costo) {
      this.$api.updateCostoPersonale(this.company.id, costo.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.personnel',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCostoPersonale(this.company.id, this.$route.params.costId)
          .then(res => {
            this.cost = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
